/* APP */

import { SET_CURRENT_SECTION, SET_VIDEO_STATUS } from './mutations';
import { UPDATE_VIDEO_STATUS } from './actions';

const state = {
    loading: true,
    loadingData: true,
    currentSection: null,
    landing: {
        msg: 'Oooh! That\'s Stupendo.us!',
        hero: {
            headline: 'We make key art, banners, and digital campaigns <span class="blue">stupendous!</span>',
            replayLabel: 'Replay Demo!',
            contactLabel: 'Contact Us!',
            videoSource: {
              desktop: {
                mp4: 'https://s3.us-east-2.amazonaws.com/stupendo.us/videos/Neo-Stupendous-DemoReel_ms_v05.mp4'
              },
              mobile: {
                mp4: 'https://s3.us-east-2.amazonaws.com/stupendo.us/videos/Neo-Stupendous-DemoReel_ms_v05_4x5.mp4'
              }
            },
            posterSource:{
              desktop:{
                poster: '/static/images/posters/stupendo.jpg'
              },
              mobile:{
                poster: '/static/images/posters/stupendoMobile.jpg'
              }
            },
            videoHasEnded: false,
            credit: '"Berserker" by <a href="http://www.modern-mothers.com" target="_blank" title="Modern Mothers">Modern Mothers</a>'
        }
    },
    about: {
        headline: '<span class="highlight blue">We\'re like the A-Team, but if MacGyver and G.I. JOE joined up, and our van was a Transformer. </span><!--  --><span class="highlight white">That\'s Stupendous!</span>',
        description: 'We’re masters of the secret art of Digital Advertising. We create delicious key art, online campaigns, banners, and microsites with even more creative horsepower than a dozen pure white cyborg unicorns all jacked up on Red Bull and 1lb bags of Skittles.'
    },
    contact: {
        thanks: {
            headline: 'Thanks!',
            description: '<span class="highlight pink">We\'ve heard the call and one of our cyber-ninja masters will be in touch with you before you can say </span><!--  --><span class="highlight white">&quot;Stupendous!&quot;</span>'
        }
    }
};

const getters = {

    LANDING: (state) => state.landing,

    ABOUT: (state) => state.about,

    CONTACT: (state) => state.contact,

    LOADING: (state) => state.loading,

    LOADING_DATA: (state) => state.loadingData,

    CURRENT_SECTION: (state) => state.currentSection,

    ROUTE_QUERY_PARAMS: (state, getters, rootState) => rootState.route.query,

    ROUTE_PARAMS: (state, getters, rootState) => {
        console.log('%cROUTE_PARAMS', 'color:lime;');
        console.log('state', state);
        console.log('getters', getters);
        console.log('rootState', rootState);
        return rootState.route.params;
    }

};

const mutations = {

    [SET_CURRENT_SECTION](state, payload) {
        console.log('%c[MUTATION] SET_CURRENT_SECTION', 'color:yellow;', payload);
        state.currentSection = payload;
    },

    [SET_VIDEO_STATUS](state, payload) {
        console.log('%c[MUTATION] SET_VIDEO_STATUS', 'color:yellow;', payload);
        state.landing.hero.videoHasEnded = payload;
    }

};

const actions = {

    [UPDATE_VIDEO_STATUS]({ commit }, payload) {
        console.log('%c[ACTION] UPDATE_VIDEO_STATUS', 'color:yellow;', payload);
        commit(SET_VIDEO_STATUS, payload);
    }

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
